import React from "react"
import TopTitle from "@components/TopTitle"
import Wrapper from "@components/Wrapper"
import WrapperInner from "@components/WrapperInner"
import styles from "./ContactSection.module.scss"
import { OutboundLink } from "@assertiv/assertiv-gatsby-plugin-google-gtag"

// Row,Col,FormLabel,Button,
import { Form, FormGroup, FormControl, FormCheck } from "react-bootstrap"

var Recaptcha = require("react-recaptcha")

export class SuccessMessage extends React.Component {
  componentDidMount() {
    this.successMessage.scrollIntoView(false)
  }

  render() {
    return (
      <div
        ref={node => (this.successMessage = node)}
        className="col-md-12 alert alert-success text-center"
      >
        <h1 className="font-weight-700">
          Thank you for your message! We will contact you as soon as possible.
        </h1>
      </div>
    )
  }
}

export class ErrorMessage extends React.Component {
  componentDidMount() {
    this.successMessage.scrollIntoView(false)
  }

  render() {
    return (
      <div
        ref={node => (this.successMessage = node)}
        className="col-md-12 alert alert-danger text-center"
      >
        <h3 className="font-weight-700">
          Oh no..! There was a problem with submitting this form. Please try
          again later!
        </h3>
      </div>
    )
  }
}

export default class ContactSection extends React.Component {
  constructor() {
    super()
    this.state = {
      fromEmail: "",
      message: "",
      name: "",
      company: "",
      subject: "",
      subscribe: false,
      recaptcha: "",
    }
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleRecaptchaVerify = response => {
    this.setState({ recaptcha: response })
  }

  handleInputChange = event => {
    const value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value
    this.setState({
      [event.target.id]: value,
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    var formData = {}
    formData.fromEmail = this.state.email
    formData.message = this.state.message
    formData.name = this.state.name
    formData.company = this.state.company
    formData.subject = this.state.subject
    formData.subscribe = this.state.subscribe
    formData.recaptcha = this.state.recaptcha

    fetch("https://" + window.location.hostname + "/api/sendmail", {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
      body: JSON.stringify(formData),
    })
      .then(results => {
        return results.json()
      })
      .then(data => {
        if (data.status == "success") {
          this.setState((prevState, props) => {
            return { showResult: true, showError: false, showSuccess: true }
          })
        } else {
          this.setState((prevState, props) => {
            return { showResult: true, showError: true, showSuccess: false }
          })
        }
      })
  }

  render() {
    return (
      <section className={styles.section + " container-fluid bg-xl-light-gray"}>
        <Wrapper className={"text-left"} gap="outer">
          <WrapperInner className={styles.wrapperInner + " row bg-white"}>
            <div className={"col-lg-12 col-xl-7 " + styles.contactParent}>
              <h1
                className={styles.title + " fs-30pt text-secondary fs-xl-36pt"}
              >
                For complete peace of mind, control and security for your
                identity management challenges (..or any other inquiries) fill
                in the form below.
              </h1>
              <div
                className={
                  styles.description +
                  " proxima-nova--light fs-16pt fs-lg-18pt mb-10"
                }
              >
                <p className="mb-10">
                  Our team looks forward to helping you. We service clients
                  across the world.
                </p>
                <p>
                  <span className="proxima-nova--bold">
                    Head Office Address:
                  </span>{" "}
                  Level 25, 300 Barangaroo Avenue, Sydney NSW 2000
                </p>
                <p>
                  <span className="proxima-nova--bold">Email:</span>{" "}
                  <OutboundLink href="mailto:contactus@engineid.com">
                    contactus@engineid.com
                  </OutboundLink>
                </p>
              </div>
              {this.state.showResult && this.state.showError ? (
                <ErrorMessage />
              ) : null}
              {this.state.showResult && this.state.showSuccess ? (
                <SuccessMessage />
              ) : null}
              <Form onSubmit={this.handleSubmit}>
                <div className={"row"}>
                  <div className="col-12 col-lg-6">
                    <FormGroup controlId="name" className="mb-4">
                      <FormControl
                        type="text"
                        placeholder="Your name:"
                        onChange={this.handleInputChange}
                      />
                    </FormGroup>
                    <FormGroup controlId="company" className="mb-4">
                      <FormControl
                        placeholder="Company:"
                        type="text"
                        onChange={this.handleInputChange}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-12 col-lg-6">
                    <FormGroup controlId="email" className="mb-4">
                      <FormControl
                        placeholder="Contact email:"
                        type="email"
                        onChange={this.handleInputChange}
                      />
                    </FormGroup>
                    <FormGroup controlId="subject" className="mb-4">
                      <FormControl
                        placeholder="Subject:"
                        type="text"
                        onChange={this.handleInputChange}
                      />
                    </FormGroup>
                  </div>
                </div>

                <div className={"row"}>
                  <div className="col-12">
                    <FormGroup controlId="message" className="mb-4">
                      <FormControl
                        placeholder="Your message:"
                        as="textarea"
                        onChange={this.handleInputChange}
                      />
                    </FormGroup>
                  </div>
                </div>
                <div className={"row mb-4"}>
                  <div className="col-1">
                    <FormCheck
                      id="subscribe"
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div className="col-11">
                    I would like to hear news from EngineID
                  </div>
                </div>
                <div className={"row"}>
                  <div className="col-12">
                    <Recaptcha
                      className="mb-4"
                      sitekey={process.env.RECAPTCHA_KEY}
                      verifyCallback={this.handleRecaptchaVerify}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <button
                      className={styles.buttonSubmitContact}
                      type="submit"
                    >
                      <span>SUBMIT</span>
                    </button>
                  </div>
                </div>
              </Form>
            </div>
            <div className={"col-lg-12 col-xl-5"}>
              <OutboundLink href="https://goo.gl/maps/Du74vXBhHUG9iJVW8" target="_blank">
                <div className={styles.map + " ml-lg-auto"}></div>
              </OutboundLink>
            </div>
          </WrapperInner>
        </Wrapper>
      </section>
    )
  }
}
